<template>
  <div>
	<!-- 设置 -->
    <div class="">
      <!--左-->
      <div class="wjTypeChildQuestion">
        <div class="tk_item" style="height: 0px !important"></div>
        <div
            class="tk_item"
            v-for="(szType, index) in szTypeList"
            :key="index"
            @click="goAnchor(szType.name)"
        >
          <div class="display_inline" style="width: 5%"></div>

          <div
            class="display_inline"
            style="width: 65%; font-size: 16px; color: gray"
          >
            <span>{{ szType.title }}</span>
          </div>
          <div class="display_inline" style="width: 25%; text-align: right">
            <img src="@/assets/tk/jt_def_icon.png" />
          </div>
        </div>
		
      </div>

      <!-- 详细题型设置 中-->
      <div class="setUp-box">
        
        <ExamTypeSetting ></ExamTypeSetting>
      </div>
	    <!-- 弹窗 -->
	  
    </div>
	
  </div>
</template>

<script>
import ExamTypeSetting from "./components/examTypeSetting.vue";
// import wxredpacket from '@/components/wxredpacket.vue';
export default {
  components: {
    ExamTypeSetting,
	// wxredpacket,
  },
  data() {
    return {
        szTypeList: [
            {
                id: 1,
                title: "基本设置",
                icon: "",
                icon1: "",
                href: "basicSet",
                name: "basicSet",
            },
            {
                id: 2,
                title: "提交后显示",
                icon: "",
                icon1: "",
                href: "submitSet",
                name: "submitSet",
            },
            {
                id: 3,
                title: "微信设置",
                icon: "",
                icon1: "",
                href: "wxSet",
                name: "wxSet",
            },
            {
                id: 4,
                title: "答题限制",
                icon: "",
                icon1: "",
                href: "answerSet",
                name: "answerSet",
            },
            {
                id: 5,
                title: "题目设置",
                icon: "",
                icon1: "",
                href: "topicsSet",
                name: "topicsSet",
            },
            {
                id: 6,
                title: "答题页显示设置",
                icon: "",
                icon1: "",
                href: "isShowSet",
                name: "isShowSet",
            },
            // {
            //     id: 7,
            //     title: "分享设置",
            //     icon: "",
            //     icon1: "",
            //     href: "shareSet",
            //     name: "shareSet",
            // },
            {
                id: 8,
                title: "防作弊设置",
                icon: "",
                icon1: "",
                href: "antiCheatingSet",
                name: "antiCheatingSet",
            },
        ],

        sendMask: false, //遮罩层和发送确认
        btnUpload: true,
        hiden: false,
        height: 0,
        resultBody: {},
        curWjInfo: {},
        ipLimitFreq: "", //每个IP答题次数状态
        wjId: "",
        wxLimitNumber: "", // 每个微信答题次数限制
        wxLimitFreqOptions: [
            { value: "0", label: "只能" },
            { value: "1", label: "每小时" },
            { value: "2", label: "每天" },
            { value: "3", label: "每周" },
            { value: "4", label: "每月" },
        ],
        pcLimitNumber: "", //每台电脑或手机答题次数限制
        ipLimitNumber: "", // 每个IP答题次数限制
        startPasswordNumber: "", //启动访问密码
        pcLimitFreq: "", //每台电脑或手机答题状态
        wxLimitFreq: "",
        startTimerState: false, // 设置开始时间状态
        answerlimit: "",
        answerNumber: "",
        endTimerState: false,
        specifiedTimerState: false,
        startSelTimer: "",
        endSelTimer: "",
        coll: [
            {
            label: "强制用户必须授权才可回答",
            value: 0,
            },
            {
            label: "非强制收集，提示用户授权，用户可跳过不提供信息",
            value: 1,
            },
        ],
        radios: "",
        Auth: [
            {
            label: "我没有微信服务号，通过神采问卷官方微信服务号来收集",
            value: 0,
            },
            {
            label:
                "我有微信服务号，希望通过自己的服务号来收集。用户将看到服务号授权页面",
            value: 1,
            },
        ],
        input: "您的答卷已提交，感谢您的参与！",
        input2: "",
        thanks: false,
        skipUrl: false,
        phoneNumber: false,
        array: [],
        options1: [],
        arr11: [],
        len: 0,
    };
  },
  mounted: function () {
    let maodian = this.GetQueryString("anchor"); //进入页面，如果带有锚点参数，则跳转至锚点地方，参数值就是id名
    if (maodian) {
      // console.log(maodian);
      this.goAnchor(maodian);
    }

    this.$forceUpdate();
    let that = this;
    var winHeight =
      document.body.clientHeight || document.documentElement.clientHeight;
    this.height = winHeight - 108;
    this.rightheight = winHeight - 60;

    window.onresize = () => {
      var winHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      this.height = winHeight - 108;
      this.rightheight = winHeight - 60;
    };

    // that.wid = sessionStorage.getItem("wid") || 0;
    // if (that.wid == 0) {
    //   this.wjadd();
    // } else {
    //   sessionStorage.setItem("wid", that.wid);
    //   this.wjinfo();
    // }
  },
  created() {
  },
  methods: {
    
	  redpacket(value){
	  },
    // 滚动
    goAnchor(aname) {
      let selector = `a[name=${aname}]`;
      var anchor = this.$el.querySelector(selector); //获取元素
      if (anchor) {
        // start
        anchor.scrollIntoView({ block: "center", behavior: "smooth" });
        // anchor.scrollIntoView();
      }
    },
    //获取参数
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },

    jumpContant() {
      this.$router.push("/contant");
    },
    clearContacts() {
      this.options1 = [];
    },
    startPsSure(value) {
      let that = this;
      let params = {
        that: that,
        url: `${that.$config.service.startuppassword}`,
        data: {
          id: that.wid,
          password: value,
        },
        method: "POST",
        cb(res) {
          if (res.code == 0) {
            console.log("设置访问密码", res);
          }
        },
      };
      that.$util.request(params);
    },
    savephone() {
      let that = this;
      let smsContactsList = [];
      for (let i = 0; i < that.array.length; i++) {
        let add = {
          cellphone: that.array[i].cellphone,
          name: that.array[i].name,
        };
        smsContactsList.push(add);
      }
      let params = {
        that: that,
        url: `${that.$config.service.addAnswerPhone}`,
        data: {
          id: that.wid,
          smsContactsList: smsContactsList,
        },
        method: "POST",
        cb(res) {
          if (res.code == 0) {
            that.phoneNumber = false;
            console.log("设置手机号限制", res);
          }
        },
      };
      that.$util.request(params);
    },
    EmptyAll() {
      this.array = [];
    },
    queryContacts() {
      let that = this;
      let params = {
        that: that,
        url: `${that.$config.service.queryContacts}`,
        data: {},
        method: "POST",
        cb(res) {
          if (res.code == 0) {
            that.options1 = res.resultBody.datas;
            // console.log("获取联系人列表", that.options1);
          }
        },
      };
      that.$util.request(params);
    },
    addright(data) {
      // console.log("2", data);
      if (data.contacts) {
        for (let i = 0; i < data.contacts.length; i++) {
          this.arr11.push(data.contacts[i]);
        }
      } else {
        this.arr11.push(data);
      }
      this.array = this.unique(this.arr11);
      // console.log("111", this.array);
      this.len = this.array.length;
    },
    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
    },
    setQuota() {
      this.$router.push("/quota");
    },
    limitPhone() {
      this.phoneNumber = true;
      this.queryContacts();
    },
    close() {
      this.hiden = false;
      this.phoneNumber = false;
    },
    customWechatSharing() {
      this.hiden = true;
    },
    jump(val) {
      let that = this;
      let id = that.wid;
      let params = {
        that: this,
        url: `${this.$config.service.setSkip}`,
        method: "POST",
        data: {
          skipUrl: that.input2,
          id: id,
          manyThanks: that.input,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("设置授权方式", res);
          }
        },
      };
      this.$util.request(params);
    },
    Customjump(val) {
      if (val == 0) {
        this.thanks = true;
        this.skipUrl = false;
      } else if (val == 1) {
        this.skipUrl = true;
        this.thanks = false;
      }
      let that = this;
      let id = that.wid;
      let params = {
        that: this,
        url: `${this.$config.service.setCustomJump}`,
        method: "POST",
        data: {
          id: id,
          customJump: val,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("设置授权方式", res);
          }
        },
      };
      this.$util.request(params);
    },
    AuthSinglechoice(val) {
      let that = this;
      let id = that.wid;
      let params = {
        that: this,
        url: `${this.$config.service.setAccreditAteMethods}`,
        method: "POST",
        data: {
          id: id,
          grantMethod: val,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("设置授权方式", res);
          }
        },
      };
      this.$util.request(params);
    },
    Singlechoice(val) {
      console.log("输出", val);
      let that = this;
      let id = that.wid;
      let params = {
        that: this,
        url: `${this.$config.service.setCollectMethods}`,
        method: "POST",
        data: {
          id: id,
          collectionMethod: val,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("设置收集方式", res);
          }
        },
      };
      this.$util.request(params);
    },
    kaiTimer() {
      console.log("开始时间", this.startSelTimer);
      console.log("结束时间", this.endSelTimer);
      // 比较开始时间是否小于结束时间
      if (this.startSelTimer != "" && this.endSelTimer != "") {
        if (
          this.endSelTimer < this.startSelTimer ||
          this.endSelTimer == this.startSelTimer
        ) {
          document.getElementById("timeId").style.display = "block";
          //this.$message.error("结束时间需要大于开始时间");
          return;
        }
      }
      document.getElementById("timeId").style.display = "none";
      let that = this;
      let id = that.wid;
      let params = {
        that: this,
        url: `${this.$config.service.updasetstartendtime}`,
        method: "POST",
        data: {
          endTime: that.endSelTimer,
          id: id,
          startTime: that.startSelTimer,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("设置时间", res);
          }
        },
      };
      this.$util.request(params);
    },
    specifiedTimer() {
      if (event.target.checked == true) {
        this.specifiedTimerState = true;
      } else if (event.target.checked == false) {
        this.specifiedTimerState = false;
      }
    },
    endTimer() {
      if (event.target.checked == true) {
        this.endTimerState = true;
      } else if (event.target.checked == false) {
        this.endTimerState = false;
      }
    },
    loadQuestionList() {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.questionlist}?id=${that.curWjInfo.id}`,
        method: "GET",
        data: {},
        cb(res) {
          if (res.code == 0) {
            that.questionlist = res.resultBody.questionsList;
            console.log(that.questionlist);
            that.resultBody = res.resultBody;
            that.wjId = res.resultBody.id;
            that.wxLimitFreq = res.resultBody.wxLimitFreq; // 每个微信答题次数状态
            that.wxLimitNumber = res.resultBody.wxLimitNumber; // 每个微信答题次数限制
            that.pcLimitNumber = res.resultBody.pcLimitNumber; // 每台电脑或手机答题次数限制
            that.ipLimitNumber = res.resultBody.ipLimitNumber; // 每个IP答题次数限制
            that.startPasswordNumber = res.resultBody.startUpPasswordNumber; //启动访问密码
            that.pcLimitFreq = res.resultBody.pcLimitFreq; // 每台电脑或手机答题状态
            that.ipLimitFreq = res.resultBody.ipLimitFreq; // 每个IP答题次数状态
            if (that.wxLimitFreq == 0) {
              that.wxLimitFreq = "只能";
            } else if (that.wxLimitFreq == 1) {
              that.wxLimitFreq = "每小时";
            } else if (that.wxLimitFreq == 2) {
              that.wxLimitFreq = "每天";
            } else if (that.wxLimitFreq == 3) {
              that.wxLimitFreq = "每周";
            } else if (that.wxLimitFreq == 4) {
              that.wxLimitFreq = "每月";
            }
            if (that.pcLimitFreq == 0) {
              that.pcLimitFreq = "只能";
            } else if (that.pcLimitFreq == 1) {
              that.pcLimitFreq = "每小时";
            } else if (that.pcLimitFreq == 2) {
              that.pcLimitFreq = "每天";
            } else if (that.pcLimitFreq == 3) {
              that.pcLimitFreq = "每周";
            } else if (that.pcLimitFreq == 4) {
              that.pcLimitFreq = "每月";
            }
            if (that.ipLimitFreq == 0) {
              that.ipLimitFreq = "只能";
            } else if (that.ipLimitFreq == 1) {
              that.ipLimitFreq = "每小时";
            } else if (that.ipLimitFreq == 2) {
              that.ipLimitFreq = "每天";
            } else if (that.ipLimitFreq == 3) {
              that.ipLimitFreq = "每周";
            } else if (that.ipLimitFreq == 4) {
              that.ipLimitFreq = "每月";
            }
          }
        },
      };
      this.$util.request(params);
    },
    wjinfo() {
      let that = this;
      let id = that.wid;
      let params = {
        that: this,
        url: `${this.$config.service.wjinfo}?id=${id}`,
        method: "POST",
        cb(res) {
          if (res.code == 0) {
            that.curWjInfo = res.resultBody;
            that.loadQuestionList();
          }
        },
      };
      this.$util.request(params);
    },
    wjadd() {
      let that = this;
      let params = {
        that: this,
        url: this.$config.service.wjadd,
        data: {
          content: "",
          wjTitle: "问卷标题",
          wjType: "问卷类型",
        },
        cb(res) {
          if (res.code == 0) {
            that.curWjInfo = res.resultBody;
            sessionStorage.setItem("wid", that.curWjInfo.id);
            that.loadQuestionList();
          }
        },
      };
      this.$util.request(params);
    },
    switchWxLimit(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setupwxlimit}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    wxLimit(e) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.updawxlimitnumber}`,
        method: "POST",
        data: {
          id: that.wjId,
          wxLimitFreq: e,
          wxLimitNumber: that.wxLimitNumber,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("管边", res);
          }
        },
      };
      this.$util.request(params);
    },
    wxlimitInput() {
      let wxlimitInputFreq = this.wxLimitFreq;
      if (wxlimitInputFreq == "只能") {
        wxlimitInputFreq = "0";
      } else if (wxlimitInputFreq == "每小时") {
        wxlimitInputFreq = "1";
      } else if (wxlimitInputFreq == "每天") {
        wxlimitInputFreq = "2";
      } else if (wxlimitInputFreq == "每周") {
        wxlimitInputFreq = "3";
      } else if (wxlimitInputFreq == "每月") {
        wxlimitInputFreq = "4";
      }
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.updawxlimitnumber}`,
        method: "POST",
        data: {
          id: that.wjId,
          wxLimitFreq: wxlimitInputFreq,
          wxLimitNumber: that.wxLimitNumber,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("管边", res);
          }
        },
      };
    },
    switchPcLimit(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setupclimit}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    wxPcLimit(e) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.pclimitnumber}`,
        method: "POST",
        data: {
          id: that.wjId,
          pcLimitFreq: e,
          pcLimitNumber: that.pcLimitNumber,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("管边", res);
          }
        },
      };
      this.$util.request(params);
    },
    wxPclimitInput() {
      let wxlimitInputFreq = this.pcLimitFreq;
      if (wxlimitInputFreq == "只能") {
        wxlimitInputFreq = "0";
      } else if (wxlimitInputFreq == "每小时") {
        wxlimitInputFreq = "1";
      } else if (wxlimitInputFreq == "每天") {
        wxlimitInputFreq = "2";
      } else if (wxlimitInputFreq == "每周") {
        wxlimitInputFreq = "3";
      } else if (wxlimitInputFreq == "每月") {
        wxlimitInputFreq = "4";
      }
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.pclimitnumber}`,
        method: "POST",
        data: {
          id: that.wjId,
          pcLimitFreq: wxlimitInputFreq,
          pcLimitNumber: that.pcLimitNumber,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("管边", res);
          }
        },
      };
      this.$util.request(params);
    },
    switchpLimit(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setupiplimit}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    wxIplimitInput() {
      let wxlimitInputFreq = this.ipLimitFreq;
      if (wxlimitInputFreq == "只能") {
        wxlimitInputFreq = "0";
      } else if (wxlimitInputFreq == "每小时") {
        wxlimitInputFreq = "1";
      } else if (wxlimitInputFreq == "每天") {
        wxlimitInputFreq = "2";
      } else if (wxlimitInputFreq == "每周") {
        wxlimitInputFreq = "3";
      } else if (wxlimitInputFreq == "每月") {
        wxlimitInputFreq = "4";
      }
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.updaipLimitNumber}`,
        method: "POST",
        data: {
          id: that.wjId,
          ipLimitFreq: wxlimitInputFreq,
          ipLimitNumber: that.ipLimitNumber,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("管边", res);
          }
        },
      };
      this.$util.request(params);
    },
    switchStartUpPassword(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setupstartuppassword}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    switchOnlyEmail(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setuponlyemail}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    switchSetStartEndTime(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setupsetstartendtime}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    startTimer() {
      if (event.target.checked == true) {
        this.startTimerState = true;
      } else if (event.target.checked == false) {
        this.startTimerState = false;
      }
    },
    switchBreakpointAnswer(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setBreakpointAnswer}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    switchOnlyWx(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setuponlywx}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    switchRecordWxUser(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setuprecordwxuser}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    switchProhibitWXShare(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setProhibitWXShare}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    switchNewMsgtoWX(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setNewMsgtoWX}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    switchNewMsgtoEmail(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setNewMsgtoEmail}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    switchIfAnswerDataLimit(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setupSetAnswerLimit}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    answerLimit(limit) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.answerlimit}`,
        method: "POST",
        data: {
          id: that.wjId,
          setAnswerLimitNumber: limit,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("管边", res);
          }
        },
      };
      this.$util.request(params);
    },
    switchPageAnswerTime(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setIfPageAnswerTime}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    answerNumbers(num) {
      // console.log(num);
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.answerTime}`,
        method: "POST",
        data: {
          id: that.wjId,
          pageAnswerTime: num,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    switchIfAllowStatistics(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setIfPageAnswerTime}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    switchIfDisplayShare(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setIfDisplayShare}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    switchCustomJump(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setIfCustomJump}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    switchShareSeoIndex(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setShareSeoIndex}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
    switchHideLogo(value) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setHideLogo}`,
        method: "POST",
        data: {
          id: that.wjId,
        },
        cb(res) {
          if (res.code == 0) {
            console.log(res);
          }
        },
      };
      this.$util.request(params);
    },
  },
};
</script>

<style scoped lang="scss">
@media (min-width: 768px) {
  .typesetting {
    width: 600px;
    margin: 62px auto;
  }
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: 992px) {
  .typesetting {
    width: 800px;
    margin: 62px auto;
  }
}
/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: 1452px) {
  .typesetting {
    width: 800px;
    margin: 62px auto;
  }
}
.answer_set_ul {
  width: 700px;
}
.button_line {
  width: 629px;
}
.button_line span i {
  width: 16px;
  height: 16px;
}
.limit_num_box {
  width: 700px;
  .limit_num {
    width: 700px;
    height: 52px;
    margin-left: 20px;
  }
}
// /deep/.limit{
//   font-size: 18px;
// }
/deep/.answer_set_ul {
  font-size: 14px;
}
.collection_method {
  width: 629px;
}
</style>
<style scoped>
.edit_namelist_right {
  width: 646px;
  height: 518px;
  float: left;
  margin-left: 25px;
}
.edit_namelist_left {
  width: 254px;
  height: 518px;
  float: left;
  margin-left: 25px;
}
.shareIng_describe img {
  width: 68px;
  height: 68px;
  float: left;
  margin-right: 20px;
}
.shareIng_describe {
  width: auto;
  height: 68px;
  margin-left: 28px;
  margin-top: 16px;
}
.wxicon_mar {
  margin-left: 28px;
  margin-top: 20px;
}
.wxicon_mar i {
  color: #09bb07;
  width: 32px;
  height: 18px;
}
.wxicon_mar span {
  font-size: 14px;
  color: #333;
  margin-left: 11px;
}
@font-face {
  font-family: "iconfont"; /* project id 2064622 */
  src: url("//at.alicdn.com/t/font_2064622_kf62i7lda0l.eot");
  src: url("//at.alicdn.com/t/font_2064622_kf62i7lda0l.eot?#iefix")
      format("embedded-opentype"),
    url("//at.alicdn.com/t/font_2064622_kf62i7lda0l.woff2") format("woff2"),
    url("//at.alicdn.com/t/font_2064622_kf62i7lda0l.woff") format("woff"),
    url("//at.alicdn.com/t/font_2064622_kf62i7lda0l.ttf") format("truetype"),
    url("//at.alicdn.com/t/font_2064622_kf62i7lda0l.svg#iconfont") format("svg");
}
.shareing_box {
  width: 650px;
  height: 406px;
  border: 1px solid #ccc;
  margin-top: 20px;
  margin-left: 25px;
}
.logo_imgStyle {
  float: left;
  width: 68px;
  height: 68px;
  margin-left: 190px;
}
.details {
  /* // 遮罩层内容 */
  position: fixed;
  background: #fff;
  width: 700px;
  height: 620px;
  overflow: auto;
  opacity: 1;
  z-index: 2001;
  top: 15%; /*偏移*/
  left: 45%;
  margin-left: -300px;
}
.detailsPhone {
  position: fixed;
  background: #fff;
  width: 980px;
  height: 660px;
  overflow: auto;
  opacity: 1;
  z-index: 1111;
  top: 10%;
  left: 40%;
  margin-left: -300px;
}
.details-1 {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #fff;
  position: relative;
  color: #333;
  /* border-bottom:1px solid #0080ff; */
  font-size: 18px;
  text-align: center;
}
.details-1 i {
  color: #999;
  position: absolute;
  right: 20px;
  top: 34%;
}
.mask {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.3;
}

/deep/.start .el-input__inner {
  width: 220px !important;
  height: 40px !important;
  border: 1px solid #ccc;
}
.start {
  margin-left: 20px;
}
.timeSetting {
  display: flex;
  height: 35px;
  line-height: 35px;
  margin-left: 20px;
}
.answerlimit {
  width: 60px;
  height: 24px;
  border: 1px solid #ccc !important;
  margin-left: 8px;
  margin-right: 8px;
}

a {
  color: #333;
}

.tk_item {
  width: 260px;
  height: 69px;
  margin: 0 auto;
  border-bottom: 1px solid #d5d5d6;
}
.display_inline {
  display: inline;
  float: left;
  height: 68px;
  line-height: 68px;
}
.answer_set {
  width: 700px;
  height: auto;
  margin: 0 auto;
}

.contact_list {
  width: 254px;
  height: 518px;
  border: 1px solid #cccccc;
}
.setContact {
  width: 254px;
  height: 43px;
  background-color: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.setContact span {
  margin-left: 15px;
  font-size: 14px;
  color: #333;
}
.setContact i {
  color: #0080ff;
  margin-right: 20px;
}
.searchInput {
  width: 243px;
  margin: 17px auto;
}
.Manually_enter_contacts {
  width: 646px;
  height: 518px;
  border: 1px solid #ccc;
}
.delContact i {
  margin-right: 15px;
  color: #0080ff;
}
.delContact span {
  margin-left: 15px;
  font-size: 14px;
  color: #333;
}
.delContact {
  width: 646px;
  height: 43px;
  display: flex;
  background: #f5f5f5;
  justify-content: space-between;
  align-items: center;
}
.custom-tree-node {
  width: 254px;
  position: relative;
}
.custom-tree-node i {
  color: #0080ff;
  position: absolute;
  right: 15px;
  top: 3px;
}
.setUp-box{
	margin-left: 362px;

}
.wjTypeChildQuestion {
  margin-left: 2px;
  width: 278px;
  height: 100%;
  background-color: #fff;
  /* padding-top:15px; */
  padding-bottom: 30px;
  float: left;
  display: inline;
  /* overflow-y: auto; */
  position: fixed;
  top: 61px;
  left: 80px;
}
/* 遮罩层 */
.sendMask {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.3;
}
</style>
